import { StepGamesType } from ".";
import Style from "./assets/Style.module.scss";

type ResultModalProps = {
  points: number;
  cantFigures: number;
  setRestartGame: React.Dispatch<React.SetStateAction<boolean>>;
  setPoints: React.Dispatch<React.SetStateAction<number>>;
  setStartGame: React.Dispatch<React.SetStateAction<StepGamesType>>;
};

export const ResultModal: React.FC<ResultModalProps> = ({
  points,
  cantFigures,
  setStartGame,
  setPoints,
  setRestartGame
}) => {
  const restartGame = () => {
    setPoints(0);
    setStartGame("startGame");
    setRestartGame(true);
  };
  return (
    <div className={Style.modalContainer}>
      <div className={Style.modal}>
        <div>
          <h2>Nivel terminado.</h2>
          <p>
            <strong>Puntos:</strong> {points}
          </p>
          <p>
            <strong>de:</strong> {cantFigures}
          </p>
          <button className='btn btn-dark' onClick={() => restartGame()}>
            Volverlo a intentar
          </button>
        </div>
      </div>
    </div>
  );
};
